module.exports = __webpack_public_path__ + "static/media/step-ladders@2x.586f14d6.png";